import React, { useContext, useEffect, useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import { TimePicker } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { DatePicker, Space } from "antd";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { pathName } from "../../utils/commonUtils";
import { SearchSelect } from "../../common/SearchSelect";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getProductHandler } from "../../redux/action/getAllProductSlice";
import { getAllGroupsHandler } from "../../redux/action/getAllGroups";
import { getAllUserHandler } from "../../redux/action/getAllUserListSlice";
import {
  notificationHandler,
  notificationsSliceAction,
} from "../../redux/action/addNotificationsSlice";
import Loader from "../../components/Loder/loader";
import * as moment from "moment";
import * as Yup from "yup";
import { useCommonMessage } from "../../common/CommonMessage";
import { ThemeContext } from "../../common/themeContext";
import {
  createNotificationSchema,
  emailSchema,
  pushDescriptionSchema,
  smsSchema,
} from "../../common/Validations";
import { getItem } from "../../common/localStorage";
import { Select } from "antd";
import { productListDropdownHandler } from "../../redux/action/productListDropdownAPI";
import { groupListDropdownHandler } from "../../redux/action/groupListDropdownAPI";
import { userListDropdownHandler } from "../../redux/action/userListDropdownAPI";
import {
  MODULE_ACCESS_DENIED_MESSAGE,
  useAdminPermissions,
  resolveModuleAccessDeniedRoute,
} from "../../hooks/useAdminPermissions";
import {
  isSuccessMessage,
  isSuccessfulApiResponse,
} from "../../common/apiResponse";

const { Option } = Select;

const CreateNotification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const messageApi = useCommonMessage();
  const { brandId } = useContext(ThemeContext);
  const {
    hasPermission,
    isSuperAdmin,
    isPending: permissionsPending,
    PERMISSIONS,
    defaultRoute,
  } = useAdminPermissions();
  const canCreateNotification =
    isSuperAdmin || hasPermission(PERMISSIONS.NOTIFICATION_EDIT);
  const canViewNotification =
    isSuperAdmin || hasPermission(PERMISSIONS.NOTIFICATION_VIEW);

  const [notificationType, setNotificationType] = useState("sms");
  const [selectLanguage, setSelectLanguage] = useState("english");
  const [getProduct, setGetProduct] = useState([]);
  const [groupsData, setGroupsData] = useState([]);
  const [userData, setUserData] = useState([]);
  const storedTheme = getItem("theme");
  // Add pagination states
  const [productPage, setProductPage] = useState(1);
  const [productLoading, setProductLoading] = useState(false);
  const [hasMoreProducts, setHasMoreProducts] = useState(true);
  const PRODUCTS_PER_PAGE = 100;
  const INITIAL_PRODUCTS = 100;

  // Add group pagination states
  const [groupPage, setGroupPage] = useState(1);
  const [groupLoading, setGroupLoading] = useState(false);
  const [hasMoreGroups, setHasMoreGroups] = useState(true);
  const GROUPS_PER_PAGE = 100;
  const INITIAL_GROUPS = 100;

  // Add member pagination states
  const [memberPage, setMemberPage] = useState(1);
  const [memberLoading, setMemberLoading] = useState(false);
  const [hasMoreMembers, setHasMoreMembers] = useState(true);
  const MEMBERS_PER_PAGE = 100;
  const INITIAL_MEMBERS = 100;

  const getAllProductList = useSelector((state) => state?.productListDropdown);

  const getAllGroupsList = useSelector((state) => state?.groupListDropdown);
  const getUserList = useSelector((state) => state?.userListDropdown);
  const getNotifications = useSelector(
    (state) => state?.notificationSliceDetails
  );

  useEffect(() => {
    if (permissionsPending || !canCreateNotification) {
      return;
    }

    handleProduct();
    handleGroup();
    handleMemberName();
  }, [permissionsPending, canCreateNotification]);

  useEffect(() => {
    if (permissionsPending || canCreateNotification) {
      return;
    }

    messageApi.showActionError(MODULE_ACCESS_DENIED_MESSAGE);
    navigate("/notification", { replace: true });
  }, [permissionsPending, canCreateNotification, messageApi, navigate]);

  const smsData = Yup.object().shape({
    ...createNotificationSchema,
    ...smsSchema,
  });
  const emailData = Yup.object().shape({
    ...createNotificationSchema,
    ...emailSchema,
  });
  const pushDescriptionData = Yup.object().shape({
    ...createNotificationSchema,
    ...pushDescriptionSchema,
  });
  useEffect(() => {
    if (
      getNotifications?.data &&
      isSuccessfulApiResponse(getNotifications.data)
    ) {
      messageApi.open({
        type: "success",
        content: getNotifications?.data?.message,
      });

      dispatch(notificationsSliceAction.notificationsDetailsSliceReset());
      navigate("/notification", { replace: true });
      return;
    }

    if (
      getNotifications?.message &&
      isSuccessMessage(getNotifications.message)
    ) {
      messageApi.open({
        type: "success",
        content: getNotifications.message,
      });

      dispatch(notificationsSliceAction.notificationsDetailsSliceReset());
      navigate("/notification", { replace: true });
      return;
    }

    if (getNotifications?.statusCode === 405) {
      messageApi.open({
        type: "warning",
        content:
          getNotifications?.message || MODULE_ACCESS_DENIED_MESSAGE,
      });
      dispatch(notificationsSliceAction.notificationsDetailsSliceReset());
      const redirectRoute = resolveModuleAccessDeniedRoute({
        canView: canViewNotification,
        canEdit: canCreateNotification,
        moduleRoute: "/notification",
        defaultRoute,
      });
      if (redirectRoute) {
        navigate(redirectRoute, { replace: true });
      }
      return;
    }

    if (getNotifications?.message) {
      messageApi.showActionError(getNotifications.message);
      dispatch(notificationsSliceAction.notificationsDetailsSliceReset());
    }
  }, [getNotifications, canViewNotification, canCreateNotification, defaultRoute, dispatch, messageApi, navigate]);

  useEffect(() => {
    if (getAllProductList?.data?.data) {
      const productData = getAllProductList?.data?.data?.map((item) => ({
        productId: item?.id,
        productName: item?.name,
        code: item?.code,
        productStatus: item?.activeStatus,
      }));

      if (productPage === 1) {
        setGetProduct(productData);
      } else {
        setGetProduct((prev) => {
          const existingIds = new Set(prev.map((p) => p.productId));
          const newProducts = productData.filter(
            (p) => !existingIds.has(p.productId)
          );
          return [...prev, ...newProducts];
        });
      }

      // Update hasMoreProducts based on the response length
      const receivedItems = productData.length;
      const expectedItems =
        productPage === 1 ? INITIAL_PRODUCTS : PRODUCTS_PER_PAGE;
      setHasMoreProducts(receivedItems >= expectedItems);
      setProductLoading(false);
    }

    if (getAllGroupsList?.data?.data) {
      const data = getAllGroupsList?.data?.data?.map((item) => {
        return {
          groupCode: item?.id,
          groupName: item?.name,
          caspioEmployerGroupCode: item?.group_Code,
        };
      });
      if (groupPage === 1) {
        setGroupsData(data);
      } else {
        setGroupsData((prev) => {
          const existingIds = new Set(prev.map((g) => g.groupCode));
          const newGroups = data.filter((g) => !existingIds.has(g.groupCode));
          return [...prev, ...newGroups];
        });
      }

      // Update hasMoreGroups based on the response length
      const receivedItems = data.length;
      const expectedItems = groupPage === 1 ? INITIAL_GROUPS : GROUPS_PER_PAGE;
      setHasMoreGroups(receivedItems >= expectedItems);
      setGroupLoading(false);
    }

    if (getUserList?.data?.data) {
      const getUser = getUserList?.data?.data.map((item) => {
        return {
          firstName: item?.firstName,
          lastName: item?.lastName,
          userId: item?.id,
          caspioUserId: item?.caspioUserId,
          memberStatus: item?.activeStatus,
        };
      });

      if (memberPage === 1) {
        setUserData(getUser);
      } else {
        setUserData((prev) => {
          const existingIds = new Set(prev.map((u) => u.userId));
          const newUsers = getUser.filter((u) => !existingIds.has(u.userId));
          return [...prev, ...newUsers];
        });
      }

      // Update hasMoreMembers based on the response length
      const receivedItems = getUser.length;
      const expectedItems =
        memberPage === 1 ? INITIAL_MEMBERS : MEMBERS_PER_PAGE;
      setHasMoreMembers(receivedItems >= expectedItems);
      setMemberLoading(false);
    }
  }, [
    getAllProductList,
    getAllGroupsList,
    getUserList,
    productPage,
    groupPage,
    memberPage,
  ]);

  const handleProduct = (searchString="") => {
    const payload = {
      offSet: 1,
      limit: INITIAL_PRODUCTS,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
      searchString:searchString
    };
    dispatch(productListDropdownHandler(payload));
  };

  const loadMoreProducts = (searchString="") => {
    if (productLoading || !hasMoreProducts) return;

    setProductLoading(true);
    const nextPage = productPage + 1;
    const payload = {
      offSet: nextPage,
      limit: PRODUCTS_PER_PAGE,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
      searchString:""
    };

    dispatch(productListDropdownHandler(payload));
    setProductPage(nextPage);
  };

  const loadMoreGroups = (searchString="") => {
    if (groupLoading || !hasMoreGroups) return;

    setGroupLoading(true);
    const nextPage = groupPage + 1;
    const payload = {
      offSet: nextPage,
      limit: GROUPS_PER_PAGE,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
      searchString:searchString
    };

    dispatch(groupListDropdownHandler(payload));
    setGroupPage(nextPage);
  };

  const loadMoreMembers = (searchString = "") => {
    if (memberLoading || !hasMoreMembers) return;

    setMemberLoading(true);
    const nextPage = memberPage + 1;
    const payload = {
      offSet: nextPage,
      limit: MEMBERS_PER_PAGE,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
      searchString:searchString
    };

    dispatch(userListDropdownHandler(payload));
    setMemberPage(nextPage);
  };

  const handleGroup = (searchString = "") => {
    const payload = {
      offSet: 1,
      limit: INITIAL_GROUPS,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
      searchString:searchString
    };
    dispatch(groupListDropdownHandler(payload));
  };

  const handleMemberName = (searchString = "") => {
    const payload = {
      offSet: 1,
      limit: INITIAL_MEMBERS,
      refBrandId: storedTheme === "healthCare" ? 1 : 2,
      searchString: searchString,
    };
    dispatch(userListDropdownHandler(payload));
  };

  const searchTimeoutRef = useRef(null);
  const handleMemberSearch = (value) => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      handleMemberName(value); 
    }, 1000); 
  };

  const searchTimeoutGroupRef = useRef(null);
  const handleGroupSearch = (value) => {
    if (searchTimeoutGroupRef.current) {
      clearTimeout(searchTimeoutGroupRef.current);
    }

    searchTimeoutGroupRef.current = setTimeout(() => {
      handleGroup(value); 
    }, 1000); 
  };

  const searchTimeoutProductRef = useRef(null);
  const handleProductSearch = (value) => {
    if (searchTimeoutProductRef.current) {
      clearTimeout(searchTimeoutProductRef.current);
    }

    searchTimeoutProductRef.current = setTimeout(() => {
      handleProduct(value); 
    }, 1000); 
  };


  const getDefaultTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const formik = useFormik({
    initialValues: {
      productName: "",
      groupName: "",
      memberName: "",
      date: null,
      time: null,
      notificationType: "sms",
      description: "",
      subject: "",
      body: "",
      title: "",
      pushDescription: "",
      language: "english",
    },
    validationSchema:
      notificationType === "sms"
        ? smsData
        : notificationType === "email"
        ? emailData
        : notificationType === "pushNotification"
        ? pushDescriptionData
        : undefined,

    validate: (values) => {
      const errors = {};
      if (!values?.productName && !values?.groupName && !values?.memberName) {
        errors.selection = "Please select at least one dropdown option";
      }
      return errors;
    },
    onSubmit: (value) => {
      const {
        productName,
        groupName,
        memberName,
        date,
        time,
        notificationType,
        description,
        subject,
        body,
        title,
        pushDescription,
      } = value;
      const payload = {
        notificationReceiver: {
          userIds: memberName
            ? userData
                .filter((user) => `${user?.caspioUserId}` === memberName)
                .map((user) => user?.userId)
            : undefined,
          productId: productName
            ? getProduct
                .filter((product) => product?.code === productName)
                .map((product) => product?.productId)
            : undefined,
          groupId: groupName
            ? groupsData
                .filter((group) => group?.caspioEmployerGroupCode === groupName)
                .map((group) => group?.groupCode)
            : undefined,
        },
        eventType: brandId === 1 ? "ADMIN_TYPE" : "ADMIN_TYPE_PC",
        notificationConfigJson: {
          sms: notificationType === "sms",
          email: notificationType === "email",
          pushNotification: notificationType === "pushNotification",
        },
        scheduledDate: new Date(`${date} ${time}`).toISOString(),
        brandId: storedTheme === "healthCare" ? 1 : 2,
        language: selectLanguage === "english" ? "en" : "es",
      };
      if (payload?.notificationConfigJson?.sms) {
        payload["sms"] = description;
      } else if (payload?.notificationConfigJson?.email) {
        payload["emailSubject"] = subject;
        payload["emailBody"] = body;
      } else if (payload?.notificationConfigJson?.pushNotification) {
        payload["pushNotificationTitle"] = title;
        payload["pushNotificationDescription"] = pushDescription;
      }
      dispatch(notificationHandler(payload, { skipForbiddenRedirect: true }));
    },
  });

  const showError =
    formik?.errors?.selection &&
    !formik?.values?.productName &&
    !formik?.values?.groupName &&
    !formik?.values?.memberName;

  const throttleRef = useRef(false);
  const createInfiniteScrollHandler = (
    loaderFn,
    loadingRef,
    hasMoreRef,
    delay = 500
  ) => {
    return (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      const scrollPercentage = (scrollTop + clientHeight) / scrollHeight;

      if (
        scrollPercentage >= 0.8 &&
        !loadingRef.current &&
        hasMoreRef.current &&
        !throttleRef.current
      ) {
        throttleRef.current = true;
        loaderFn();

        setTimeout(() => {
          throttleRef.current = false;
        }, delay);
      }
    };
  };

  const groupLoadingRef = useRef(groupLoading);
  const hasMoreGroupsRef = useRef(hasMoreGroups);
  const productLoadingRef = useRef(productLoading);
  const hasMoreProductsRef = useRef(hasMoreProducts);

  const memberLoadingRef = useRef(memberLoading);
  const hasMoreMemberRef = useRef(hasMoreMembers);

  // Keep these refs in sync with latest values
  useEffect(() => {
    groupLoadingRef.current = groupLoading;
    hasMoreGroupsRef.current = hasMoreGroups;
    productLoadingRef.current = productLoading;
    hasMoreProductsRef.current = hasMoreProducts;
    memberLoadingRef.current = memberLoading;
    hasMoreMemberRef.current = hasMoreMembers;
  }, [
    groupLoading,
    hasMoreGroups,
    productLoading,
    hasMoreProducts,
    memberLoading,
    hasMoreMembers,
  ]);

  const handleGroupScroll = createInfiniteScrollHandler(
    loadMoreGroups,
    groupLoadingRef,
    hasMoreGroupsRef
  );
  const handleProductScroll = createInfiniteScrollHandler(
    loadMoreProducts,
    productLoadingRef,
    hasMoreProductsRef
  );
  const handleMemberScroll = createInfiniteScrollHandler(
    loadMoreMembers,
    memberLoadingRef,
    hasMoreMemberRef
  );

  if (permissionsPending || !canCreateNotification) {
    return <Loader loaderTransForm="loaderTransForm" />;
  }

  return (
    <>
      {getNotifications?.isLoading === true && (
        <Loader loaderTransForm="loaderTransForm" />
      )}
      <div className="rightside">
        <div className="rightcontent">
          <p>
            <strong>Notifications</strong>
          </p>
          <CustomBreadcrumb
            items={[
              { text: "Home" },
              {
                text: "Notifications",
                onClick: () => navigate("/notification"),
              },
              { text: pathName(location), active: true },
            ]}
          />
          {/* Create */}
          <form onSubmit={formik?.handleSubmit}>
            <div className="sectionpadding mb-30">
              <p className="mb-0 heedprodct">Create Notification</p>
              <hr />
              <div className="d-xxl-flex align-items-center mb-30">
                <div className="pe-xxl-2 me-xxl-2 selecttype selecttype">
                  <p className="labelp">Product Name*</p>
                  <SearchSelect
                    value={formik?.values?.productName || "Search for Product"}
                    options={getProduct
                      ?.filter(
                        (item) =>
                          item?.productStatus?.toLowerCase() === "active" ||
                          item?.productStatus?.toLowerCase() === "activestatus"
                      )
                      .map((data) => {
                        return {
                          value: data?.code,
                          label: data?.productName + " " + `(${data?.code})`,
                        };
                      })}
                    onBlur={() => {}}
                    onChange={(value) => {
                      formik.setFieldValue("productName", value);
                      formik.setTouched(false);
                      formik.setFieldValue("groupName", null);
                      formik.setFieldValue("memberName", null);
                    }}
                    onPopupScroll={handleProductScroll}
                    id="productName"
                    placeholder="Search for Product"
                    // loading={productLoading}
                    menuItemScrollable={true}
                    listHeight={256}
                    dropdownStyle={{ maxHeight: "256px" }}
                    onDropdownVisibleChange={(open) => {
                      if (open && getProduct?.length === 0) {
                        handleProduct("");
                      }
                    }}
                    onSearch={handleProductSearch}
                    loading={getAllProductList?.isLoading}
                  />
                  {showError && (
                    <div className="error">{formik?.errors?.selection}</div>
                  )}
                </div>
                <div className="pe-xxl-2 me-xxl-2">
                  <p className="my-3 mt-xxl-5"> OR</p>
                </div>
                <div className="pe-xxl-2 me-xxl-2 selecttype selecttype">
                  <p className="labelp">Select Group*</p>
                  <SearchSelect
                    value={formik?.values?.groupName || "Search for Group"}
                    options={groupsData.map((data) => {
                      return {
                        value: data?.caspioEmployerGroupCode,
                        label:
                          data?.groupName +
                          " " +
                          `(${data?.caspioEmployerGroupCode})`,
                      };
                    })}
                    onBlur={() => {}}
                    onChange={(value) => {
                      formik.setFieldValue("groupName", value);
                      formik.setTouched(false);
                      formik.setFieldValue("productName", null);
                      formik.setFieldValue("memberName", null);
                    }}
                    onPopupScroll={handleGroupScroll}
                    id={"groupName"}
                    placeholder="Search for Group"
                    // loading={groupLoading}
                    menuItemScrollable={true}
                    listHeight={256}
                    dropdownStyle={{ maxHeight: "256px" }}
                    onDropdownVisibleChange={(open) => {
                      if (open && groupsData?.length === 0) {
                        handleGroup("");
                      }
                    }}
                    onSearch={handleGroupSearch}
                    loading={getAllGroupsList?.isLoading}
                  />
                  {showError && (
                    <div className="error">{formik?.errors?.selection}</div>
                  )}
                </div>
                <div className="pe-xxl-2 me-xxl-2">
                  <p className="my-3 mt-xxl-5"> OR</p>
                </div>
                <div className="pe-xxl-2 me-xxl-2 selecttype selecttype">
                  <p className="labelp">Select Member*</p>
                  <SearchSelect
                    options={userData
                      .filter(
                        (item) =>
                          item?.memberStatus?.toLowerCase() === "active" ||
                          item?.memberStatus?.toLowerCase() === "activestatus"
                      )
                      ?.map((data) => {
                        return {
                          value: data?.caspioUserId,
                          label:
                            data?.firstName +
                            " " +
                            data?.lastName +
                            " " +
                            `(${data?.caspioUserId})`,
                        };
                      })}
                    onBlur={() => {}}
                    value={formik?.values?.memberName || "Select Member"}
                    onChange={(value) => {
                      formik.setFieldValue("memberName", value);
                      formik.setTouched(false);
                      formik.setFieldValue("groupName", null);
                      formik.setFieldValue("productName", null);
                    }}
                    onPopupScroll={handleMemberScroll}
                    id={"memberName"}
                    placeholder="Select Member"
                    // loading={memberLoading}
                    menuItemScrollable={true}
                    listHeight={256}
                    dropdownStyle={{ maxHeight: "256px" }}
                    onDropdownVisibleChange={(open) => {
                      if (open && userData?.length === 0) {
                        handleMemberName("");
                      }
                    }}
                    onSearch={handleMemberSearch}
                    loading={getUserList?.isLoading}
                  />
                  {showError && (
                    <div className="error">{formik?.errors?.selection}</div>
                  )}
                </div>
              </div>
              <div className="d-xxl-flex align-items-center mb-30">
                <div className="pe-xxl-2 me-xxl-2  mb-xxl-0 mb-3 selecttype">
                  <p className="labelp">Select Date*</p>
                  <Space direction="vertical" className="noicon">
                    <DatePicker
                      placeholder="YYYY-MM-DD"
                      format="YYYY-MM-DD"
                      onChange={(date, dateString) => {
                        formik.setFieldValue("date", dateString);
                      }}
                      disabledDate={(current) => {
                        return current && current < moment().startOf("day");
                      }}
                      allowClear={false}
                    />
                  </Space>
                  {formik?.touched?.date && formik?.errors?.date && (
                    <div style={{ color: "red" }}>{formik?.errors?.date}</div>
                  )}
                </div>
                <div className="pe-xxl-2 me-xxl-4">
                  <p className="my-3 mt-xxl-5">&</p>
                </div>
                <div className="pe-xxl-2 me-xxl-2 mb-xxl-0 mb-3 selecttype">
                  <p className="labelp">Select time*</p>
                  <Space direction="vertical" className="noicon">
                    <TimePicker
                      format="HH:mm"
                      onChange={(time, timeString) => {
                        if (timeString) {
                          formik.setFieldValue("time", timeString);
                        } else {
                          formik.setFieldValue("time", getDefaultTime());
                        }
                      }}
                      allowClear={false}
                    />
                  </Space>
                  {formik?.touched?.time && formik?.errors?.time && (
                    <div style={{ color: "red" }}>{formik?.errors?.time}</div>
                  )}
                </div>
              </div>
              <div className="seprator"></div>
              {/* Select Language */}
              <div className="">
                <p className="notification-type">Select Language</p>
              </div>
              <div className="">
                <Form.Check
                  inline
                  type="radio"
                  label="English"
                  value="english"
                  name="english"
                  id="english"
                  className="custom-radio cursor-pointer"
                  checked={selectLanguage === "english"}
                  onChange={(e) => {
                    setSelectLanguage(e?.target?.value);
                    formik.setValues({
                      ...formik.values,
                      selectLanguage: e?.target?.value,
                    });
                  }}
                />
                <Form.Check
                  inline
                  type="radio"
                  label="Spanish"
                  value="spanish"
                  name="spanish"
                  id="spanish"
                  className="custom-radio"
                  checked={selectLanguage === "spanish"}
                  onChange={(e) => {
                    setSelectLanguage(e?.target?.value);
                    formik.setValues({
                      ...formik?.values,
                      selectLanguage: e?.target?.value,
                    });
                  }}
                />
              </div>
              <div className="seprator"></div>
              {/* Select any one Notification Type */}
              <div className="">
                <p className="notification-type">
                  Select any one Notification Type
                </p>
              </div>
              <div className="">
                <Form.Check
                  inline
                  type="radio"
                  label="SMS"
                  value="sms"
                  name="inlineRadioOptions"
                  id="inlineRadio1"
                  className="custom-radio cursor-pointer"
                  checked={notificationType === "sms"}
                  onChange={(e) => {
                    setNotificationType(e?.target?.value);
                    formik.setValues({
                      ...formik.values,
                      notificationType: e?.target?.value,
                    });
                  }}
                />
                <Form.Check
                  inline
                  type="radio"
                  label="Email"
                  value="email"
                  name="inlineRadioOptions"
                  id="inlineRadio2"
                  className="custom-radio"
                  checked={notificationType === "email"}
                  onChange={(e) => {
                    setNotificationType(e?.target?.value);
                    formik.setValues({
                      ...formik?.values,
                      notificationType: e?.target?.value,
                    });
                  }}
                />
                <Form.Check
                  inline
                  type="radio"
                  label="Push Notification"
                  value="pushNotification"
                  name="inlineRadioOptions"
                  id="inlineRadio3"
                  className="custom-radio"
                  checked={notificationType === "pushNotification"}
                  onChange={(e) => {
                    setNotificationType(e?.target?.value);
                    formik.setValues({
                      ...formik?.values,
                      notificationType: e?.target?.value,
                    });
                  }}
                />
              </div>

              <div className="mt-4">
                {notificationType === "sms" && (
                  <div className="mb-2 login-form">
                    <p className="labelp">Description*</p>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      placeholder="Description"
                      value={formik?.values?.description}
                      onChange={(e) =>
                        formik.setFieldValue("description", e?.target?.value)
                      }
                      maxLength={150}
                    />
                    {formik?.touched?.description &&
                      formik?.errors?.description && (
                        <div style={{ color: "red" }}>
                          {formik?.errors?.description}
                        </div>
                      )}
                  </div>
                )}
                {notificationType === "email" && (
                  <>
                    <div className="mb-2 login-form">
                      <p className="labelp">Subject*</p>
                      <Form.Control
                        className="selectdisplayed"
                        type="text"
                        placeholder="Subject"
                        value={formik?.values?.subject}
                        onChange={(e) =>
                          formik.setFieldValue("subject", e?.target?.value)
                        }
                        maxLength={100}
                      />
                      {formik?.touched?.subject && formik?.errors?.subject && (
                        <div style={{ color: "red" }}>
                          {formik?.errors?.subject}
                        </div>
                      )}
                    </div>
                    <div className="mb-2 login-form">
                      <p className="labelp">Body*</p>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Body"
                        value={formik?.values?.body}
                        onChange={(e) =>
                          formik.setFieldValue("body", e?.target?.value)
                        }
                        maxLength={250}
                      />
                      {formik?.touched?.body && formik?.errors?.body && (
                        <div style={{ color: "red" }}>
                          {formik?.errors?.body}
                        </div>
                      )}
                    </div>
                  </>
                )}
                {notificationType === "pushNotification" && (
                  <>
                    <div className="mb-2 login-form">
                      <p className="labelp">Title*</p>
                      <Form.Control
                        className="selectdisplayed"
                        type="text"
                        placeholder="Title"
                        value={formik?.values?.title}
                        onChange={(e) =>
                          formik.setFieldValue("title", e?.target?.value)
                        }
                        maxLength={60}
                      />
                      {formik?.touched?.title && formik?.errors?.title && (
                        <div style={{ color: "red" }}>
                          {formik?.errors?.title}
                        </div>
                      )}
                    </div>
                    <div className="mb-2 login-form">
                      <p className="labelp">Description*</p>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Description"
                        value={formik?.values?.pushDescription}
                        onChange={(e) =>
                          formik.setFieldValue(
                            "pushDescription",
                            e?.target?.value
                          )
                        }
                        maxLength={150}
                      />
                      {formik?.touched?.pushDescription &&
                        formik?.errors?.pushDescription && (
                          <div style={{ color: "red" }}>
                            {formik?.errors?.pushDescription}
                          </div>
                        )}
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="text-end mt-30 bgt">
              <button
                type="submit"
                className="sbg border-0 py3 fw-18 gbo continuebtn savebtn"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreateNotification;
